import { Brain } from "lucide-react";
import {
  APP_NAME,
  APP_TAGLINE,
  APP_DESCRIPTION,
  APP_FEATURES,
  APP_GOOGLE_DATA_NOTE,
} from "@/lib/appMarketingCopy";

export function AuthMarketingPanel() {
  return (
    <div className="flex flex-col justify-center px-6 py-10 md:px-10 md:py-12 lg:px-16">
      <div className="flex items-center gap-3 mb-6">
        <div className="h-12 w-12 rounded-lg bg-primary flex items-center justify-center shrink-0">
          <Brain className="h-6 w-6 text-primary-foreground" />
        </div>
        <h1 className="text-2xl font-bold tracking-tight">{APP_NAME}</h1>
      </div>

      <p className="text-lg font-medium text-foreground mb-3">{APP_TAGLINE}</p>
      <p className="text-muted-foreground mb-8 max-w-md">{APP_DESCRIPTION}</p>

      <ul className="space-y-4 mb-8">
        {APP_FEATURES.map((feature) => (
          <li key={feature.title} className="flex gap-3">
            <div className="mt-1 h-2 w-2 rounded-full bg-primary shrink-0" />
            <div>
              <p className="font-medium text-sm">{feature.title}</p>
              <p className="text-sm text-muted-foreground">{feature.description}</p>
            </div>
          </li>
        ))}
      </ul>

      <p className="text-xs text-muted-foreground max-w-md border-l-2 border-primary/30 pl-3">
        {APP_GOOGLE_DATA_NOTE}
      </p>
    </div>
  );
}
